/**
 * Buy Box Coffee - Side-by-Side Subscription Cards
 * Based on Buy Box V2 JS architecture — matched exactly.
 * 
 * CART LOGIC:
 * - 2-Week: quantity 1 + selling plan 1 (from data attribute)
 * - 4-Week: quantity 1 + selling plan 2 (from data attribute)
 * - One-Time: quantity 1, NO selling plan
 */

(function() {
  'use strict';

  // Prevent multiple script loads from stacking listeners
  if (window.__buyBoxCoffeeLoaded) return;
  window.__buyBoxCoffeeLoaded = true;

  // Initialize all buy boxes on the page — same as v2, single init point
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.buy-box-coffee').forEach(initBuyBox);
  });

  // Also init immediately if DOM is already ready (deferred script after re-render)
  if (document.readyState !== 'loading') {
    document.querySelectorAll('.buy-box-coffee').forEach(initBuyBox);
  }

  function initBuyBox(container) {
    if (container.dataset.bbcInit) return;
    container.dataset.bbcInit = '1';
    initGallery(container);
    initPlanSelection(container);
    initSocialProofScroll(container);
  }

  function initSocialProofScroll(container) {
    var socialProof = container.querySelector('.buy-box-coffee__social-proof--clickable');
    if (!socialProof) return;

    var reviewsId = socialProof.dataset.reviewsId;
    if (!reviewsId) return;

    socialProof.addEventListener('click', function(e) {
      e.preventDefault();
      var el = document.getElementById(reviewsId);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  function initGallery(container) {
    var gallery = container.querySelector('.buy-box-coffee__gallery');
    if (!gallery) return;

    var images = gallery.querySelectorAll('.buy-box-coffee__gallery-image');
    var thumbnails = gallery.querySelectorAll('.buy-box-coffee__thumbnail');
    var prevBtn = gallery.querySelector('.buy-box-coffee__gallery-arrow--prev');
    var nextBtn = gallery.querySelector('.buy-box-coffee__gallery-arrow--next');
    var counter = gallery.querySelector('.buy-box-coffee__gallery-current');
    
    if (images.length === 0) return;
    var currentIndex = 0;

    function showImage(index) {
      if (index < 0) index = images.length - 1;
      if (index >= images.length) index = 0;
      currentIndex = index;

      images.forEach(function(img, i) {
        img.classList.toggle('buy-box-coffee__gallery-image--active', i === currentIndex);
      });
      thumbnails.forEach(function(thumb, i) {
        thumb.classList.toggle('buy-box-coffee__thumbnail--active', i === currentIndex);
      });
      if (counter) counter.textContent = currentIndex + 1;
    }

    if (prevBtn) prevBtn.addEventListener('click', function(e) { e.preventDefault(); e.stopPropagation(); showImage(currentIndex - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function(e) { e.preventDefault(); e.stopPropagation(); showImage(currentIndex + 1); });

    thumbnails.forEach(function(thumb) {
      thumb.addEventListener('click', function(e) {
        e.preventDefault();
        showImage(parseInt(this.dataset.index, 10));
      });
    });

    gallery.addEventListener('keydown', function(e) {
      if (e.key === 'ArrowLeft') showImage(currentIndex - 1);
      else if (e.key === 'ArrowRight') showImage(currentIndex + 1);
    });

    var touchStartX = 0;
    var galleryMain = gallery.querySelector('.buy-box-coffee__gallery-main');
    if (galleryMain) {
      galleryMain.addEventListener('touchstart', function(e) { touchStartX = e.changedTouches[0].screenX; }, { passive: true });
      galleryMain.addEventListener('touchend', function(e) {
        var diff = touchStartX - e.changedTouches[0].screenX;
        if (Math.abs(diff) > 50) {
          showImage(diff > 0 ? currentIndex + 1 : currentIndex - 1);
        }
      }, { passive: true });
    }
  }

  /**
   * Plan selection — matched to buy-box-v2 logic exactly
   */
  function initPlanSelection(container) {
    var allPlans = container.querySelectorAll('.buy-box-coffee__plan');
    var subscriptionPlans = container.querySelectorAll('.buy-box-coffee__plan:not(.buy-box-coffee__plan--onetime)');
    var onetimePlan = container.querySelector('.buy-box-coffee__plan--onetime');
    var primaryCta = container.querySelector('.buy-box-coffee__cta--primary');
    var perksContainer = container.querySelector('.buy-box-coffee__perks');

    var variantId = container.dataset.variantId;
    var hasSellingPlan = container.dataset.hasSellingPlan === 'true';

    var selectedPlan = 'biweekly';

    function updatePrimaryCtaState() {
      if (!primaryCta) return;
      var isOnetime = onetimePlan && onetimePlan.classList.contains('buy-box-coffee__plan--selected');
      if (isOnetime) {
        primaryCta.classList.add('buy-box-coffee__cta--faded');
      } else {
        primaryCta.classList.remove('buy-box-coffee__cta--faded');
      }
    }

    function updateDynamicPerk() {
      if (!perksContainer) return;
      var dynamicPerk = perksContainer.querySelector('.buy-box-coffee__perk--dynamic span');
      if (!dynamicPerk) return;
      var text = selectedPlan === 'monthly' 
        ? perksContainer.dataset.perkMonthly 
        : perksContainer.dataset.perkBiweekly;
      if (text) dynamicPerk.textContent = text;
    }

    // Subscription plan clicks
    subscriptionPlans.forEach(function(plan) {
      plan.addEventListener('click', function() {
        allPlans.forEach(function(p) { p.classList.remove('buy-box-coffee__plan--selected'); });
        this.classList.add('buy-box-coffee__plan--selected');
        selectedPlan = this.dataset.plan;
        updatePrimaryCtaState();
        updateDynamicPerk();
        if (perksContainer) perksContainer.style.display = '';
      });
    });

    // One-time plan click — same as v2
    if (onetimePlan) {
      onetimePlan.addEventListener('click', function(e) {
        if (e.target.closest('.buy-box-coffee__cta--secondary')) return;
        
        subscriptionPlans.forEach(function(p) { p.classList.remove('buy-box-coffee__plan--selected'); });
        this.classList.add('buy-box-coffee__plan--selected');
        selectedPlan = 'onetime';
        updatePrimaryCtaState();
        if (perksContainer) perksContainer.style.display = 'none';
      });

      // One-time CTA — no selling plan
      var onetimeCta = onetimePlan.querySelector('.buy-box-coffee__cta--secondary');
      if (onetimeCta) {
        onetimeCta.addEventListener('click', function(e) {
          e.stopPropagation();
          if (variantId) {
            addToCart(variantId, 1, null, container);
          }
        });
      }
    }

    // Primary CTA — subscription with selling plan
    if (primaryCta) {
      primaryCta.addEventListener('click', function(e) {
        e.preventDefault();

        var isOnetime = onetimePlan && onetimePlan.classList.contains('buy-box-coffee__plan--selected');
        if (isOnetime) {
          if (subscriptionPlans.length > 0) {
            allPlans.forEach(function(p) { p.classList.remove('buy-box-coffee__plan--selected'); });
            subscriptionPlans[0].classList.add('buy-box-coffee__plan--selected');
            selectedPlan = subscriptionPlans[0].dataset.plan;
            updatePrimaryCtaState();
            updateDynamicPerk();
            if (perksContainer) perksContainer.style.display = '';
          }
          return;
        }

        var selectedCard = container.querySelector('.buy-box-coffee__plan--selected:not(.buy-box-coffee__plan--onetime)');
        if (!selectedCard) return;

        var quantity = parseInt(selectedCard.dataset.quantity, 10) || 1;
        var sellingPlanId = selectedCard.dataset.sellingPlan;

        if (variantId) {
          if (hasSellingPlan && sellingPlanId) {
            addToCart(variantId, quantity, sellingPlanId, container);
          } else {
            addToCart(variantId, quantity, null, container);
          }
        }
      });
    }
  }

  /**
   * Add to cart — matched to buy-box-v2 exactly (no extra fetch wrapper)
   */
  function addToCart(variantId, quantity, sellingPlanId, container) {
    if (!variantId) return;

    var item = {
      id: parseInt(variantId.toString().replace(/\D/g, ''), 10),
      quantity: quantity
    };

    if (sellingPlanId) {
      item.selling_plan = parseInt(sellingPlanId.toString().replace(/\D/g, ''), 10);
    }

    var formData = { items: [item] };

    // Loading state scoped to this section
    var ctaButtons = container.querySelectorAll('.buy-box-coffee__cta');
    ctaButtons.forEach(function(btn) {
      btn.classList.add('buy-box-coffee__cta--loading');
      btn.disabled = true;
    });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(function(response) {
      if (!response.ok) {
        return response.json().then(function(err) {
          throw new Error(err.message || err.description || 'Failed to add to cart');
        });
      }
      return response.json();
    })
    .then(function(data) {
      console.log('Buy Box Coffee: Added to cart', data);

      ctaButtons.forEach(function(btn) {
        btn.classList.remove('buy-box-coffee__cta--loading');
        btn.disabled = false;
      });

      // Open cart drawer directly — same as v2
      openCartDrawer();
    })
    .catch(function(error) {
      console.error('Buy Box Coffee: Error adding to cart', error);

      ctaButtons.forEach(function(btn) {
        btn.classList.remove('buy-box-coffee__cta--loading');
        btn.disabled = false;
      });

      alert('Error: ' + error.message);
    });
  }

  /**
   * Open cart drawer — same as buy-box-v2
   */
  function openCartDrawer() {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:open'));
    document.dispatchEvent(new CustomEvent('theme:cart:open'));

    var cartTriggers = [
      '[data-cart-trigger]', '.js-cart-trigger', '.cart-icon',
      '[data-action="open-drawer"][data-drawer="cart"]',
      '#cart-icon', '.header__icon--cart', '[href="/cart"]'
    ];

    var drawerOpened = false;

    for (var i = 0; i < cartTriggers.length; i++) {
      var trigger = document.querySelector(cartTriggers[i]);
      if (trigger && typeof trigger.click === 'function') {
        var isDrawer = trigger.hasAttribute('data-cart-trigger') || trigger.hasAttribute('data-action') || trigger.classList.contains('js-cart-trigger');
        if (isDrawer) { trigger.click(); drawerOpened = true; break; }
      }
    }

    var drawerSelectors = ['.cart-drawer', '#cart-drawer', '.drawer--cart', '[data-drawer="cart"]', '.mini-cart', '.cart-flyout'];
    for (var j = 0; j < drawerSelectors.length; j++) {
      var drawer = document.querySelector(drawerSelectors[j]);
      if (drawer) {
        drawer.classList.add('is-open', 'active', 'open');
        drawerOpened = true;
        var overlay = document.querySelector('.drawer-overlay, .cart-overlay');
        if (overlay) overlay.classList.add('is-open', 'active');
        break;
      }
    }

    if (!drawerOpened) {
      setTimeout(function() {
        var visibleDrawer = document.querySelector('.cart-drawer.is-open, .drawer--cart.active, [data-drawer="cart"].open');
        if (!visibleDrawer) window.location.href = '/cart';
      }, 300);
    }
  }

})();
